// Active-drivers list — same query key as the diary selector so the
// cache is shared. Read-only.
//
// Server cap (server/src/modules/drivers/drivers.types.ts
// `listDriversQuerySchema`): `limit` is `.max(100)`. Higher values fail
// Zod validation with a 400 ValidationError. We send `limit: 100` —
// every realistic deployment has fewer than 100 active drivers; if a
// tenant ever exceeds that we'd need to paginate (out of scope for B3).

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import type { DriverListResponse, DriverSummary } from '../../../types/api';

const STALE_15_MIN = 15 * 60 * 1000;
const DRIVER_LIST_LIMIT = 100;

export function useActiveDrivers() {
  return useQuery<DriverSummary[]>({
    queryKey: queryKeys.diary.drivers,
    queryFn: async () => {
      const res = await apiClient.get<DriverListResponse>(
        endpoints.drivers.list,
        { params: { status: 'active', limit: DRIVER_LIST_LIMIT } },
      );
      return res.data?.drivers ?? [];
    },
    staleTime: STALE_15_MIN,
  });
}
